/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

export enum ClaimType {
    Claim = "CLAIM",
    Unclaim = "UNCLAIM",
}

export enum ShiftClaimsStatus {
    Pending = "PENDING",
    Success = "SUCCESS",
    Failure = "FAILURE",
}

export type ShiftClaimsError = {
    message: string;
    errorKey: string;
};
export interface ShiftClaim {
    shiftId: string;
    status: ShiftClaimsStatus;
    claimType: ClaimType;
    error?: ShiftClaimsError;
}

export interface ShiftClaimsPollingState {
    shiftClaims: ShiftClaim[];
    shiftClaimsNotifications: ShiftClaim[];
}
